import { useNavigate, useLocation } from "react-router-dom";

export default function AdminAttendanceTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const tabs = [
    { label: "QR Code", path: "/admin-attendance" },
    { label: "History", path: "/attendance-history" },
    { label: "Players' Leave", path: "/player-leave-list" },
    { label: "Summary", path: "/monthly-attendance-summary" },
  ];

  return (
    <div className="flex justify-center mt-2 mb-4 border-b">
      {tabs.map((t) => {
        const active = pathname.startsWith(t.path);
        return (
          <button
            key={t.path}
            onClick={() => navigate(t.path)}
            className={`
              px-3 py-1 border text-sm
              ${active ? "bg-blue-600 text-white font-semibold"
                       : "bg-white text-gray-700"}
            `}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
